import "./CategoryCard.css";

import {
  DEFAULT_SUPPORT_ICON,
  SUPPORT_CATEGORY_ICONS,
} from "../constants/icons";

import { getText } from "../helpers/supportHelpers";
import { Card } from "../../../ui";

const CategoryCard = ({ category, selected, onClick, lang = "ar" }) => {
  const Icon = SUPPORT_CATEGORY_ICONS[category?.code] || DEFAULT_SUPPORT_ICON;

  return (
   <Card
  className={`support-category-card ${selected ? "selected" : ""}`}
  onClick={onClick}
>
  <div className="support-category-icon">
    <Icon size={20} strokeWidth={2} />
  </div>

  <div className="support-category-name">
    <p>{getText(category?.name, lang)}</p>

    {getText(category?.description, lang) && (
      <div className="support-category-description">
        {getText(category?.description, lang)}
      </div>
    )}
  </div>
</Card>
  );
};

export default CategoryCard;
